// TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// SLIDER (SLICK JS)
// PRODUCT PICKER
// NEWSLETTER PICKER


//
// =GSAP
// --------------------------------------------------

if (window.matchMedia(`(prefers-reduced-motion: no-preference)`) === true ||
  window.matchMedia(`(prefers-reduced-motion: no-preference)`).matches === true) {

  gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.config({
    autoRefreshEvents: "DOMContentLoaded,load,resize",
  });

  const pictures = gsap.utils.toArray(".msdw-sticky-slider > picture");
  const numPictures = pictures.length - 1;

  gsap.to('.msdw-sticky-slider', {
    xPercent: -100 * numPictures,
    ease: "none",
    scrollTrigger: {
      trigger: '.msdw-pin-wrapper',
      pin: true,
      scrub: true,
      start: "top 60px",
      end: () => `+=${window.innerWidth * 2}`,
      // markers: true,
    }
  });
}

window.addEventListener('resize', () => ScrollTrigger.refresh());


//
// =SLIDER (SWIPER JS)
// --------------------------------------------------


const sliderMobile = new Swiper('#sliderMobile', {
  slidesPerView: "auto",
  spaceBetween: 10,
  grabCursor: true,
  loop: false,
  breakpoints: {
    600: {
      spaceBetween: 15,
    },
    900: {
      spaceBetween: 0,
      grabCursor: false,
    },
  },
});
